<script lang="ts">
  import {
    Follower,
    Following,
    Likes,
  } from "../../../../utils/Constant/Constant";
  import Counter from "svelte-counter";
  export let counters = {
    follwer: 325,
    following: 450,
    likes: 500,
  };
</script>

<ul class="follow-list">
  <li>
    <Counter
      values={counters}
      duration="4000"
      random="false"
      minspeed="200"
      let:counterResult
    >
      <div class="follow-num counter">{counterResult.follwer}</div>
    </Counter>
    <span>{Follower}</span>
  </li>
  <li>
    <Counter
      values={counters}
      duration="4000"
      random="false"
      minspeed="200"
      let:counterResult
    >
      <div class="follow-num counter">{counterResult.following}</div>
    </Counter>
    <span>{Following}</span>
  </li>
  <li>
    <Counter
      values={counters}
      duration="4000"
      random="false"
      minspeed="200"
      let:counterResult
    >
      <div class="follow-num counter">{counterResult.likes}</div>
    </Counter>
    <span>{Likes}</span>
  </li>
</ul>
